import { gql } from 'graphql-request'

export const QueryBenefitBlock = gql`
  fragment FragmentBenefitBlock on BenefitBlockModelRecord {
  __typename
  id
  number
  unit
  title
  description {
    value
  }
}
`
